<template>
  <h3>{{ $e("Missions") }} :</h3>
  <div class="mt-4 overflow-x-auto">
    <template v-for="mission in missionsCurrentSite" :key="mission.mis_id">
      <div
        class="p-2 flex hover:bg-flyingeye-light cursor-pointer items-center justify-between"
        :class="mission_crea_vol == mission.mis_id ? '!bg-flyingeye' : ''"
        @click="
          mission_crea_vol = mission.mis_id;
          selectFlight(mission);
        "
      >
        <div class="flex">
          <Mission_Info_List_small :mission="mission" />
        </div>
        <div
          @click="create_flight(mission.mis_id)"
          style="box-shadow: #333333 0px 1px 10px 1px; border-radius: 500px"
        >
          <SVG name="play" css="w-[25px] text-flyingeye"></SVG>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { ref } from "vue";
import { parse } from "wellknown";
import { toast } from "vue3-toastify";

import API from "@/utils/API";
import Map from "@/utils/Map.js";
import SVG from "@/partials/SVG.vue";

import Mission_Info_List_small from "@/partials/Mission/Mission_Info_List_small.vue";

export default {
  name: "Popup_Mission",
  components: {
    Mission_Info_List_small,
    SVG,
  },
  props: {
    config: Object,
  },
  setup() {
    return {
      sit_id: ref(null),
      mission_crea_vol: ref(""),
      missionsActive: ref([]),
      missionsCurrentSite: ref([]),

      store_crea_vol: ref(false),
      batt_crea_vol: ref(false),
      takeOffSecurityHeight: ref(0),
      openSelectMission: ref(false),
      safeheight_crea_vol: ref(0),
      clearOnUnmount: ref(true),
    };
  },

  async mounted() {
    this.sit_id = this.config.deviceFamilly.sit_id;
    console.log(this.config.deviceFamilly);
    this.clearFlight();
    let missions = await API.get("mission", {});
    missions = missions.reverse();
    this.missionsActive = missions.filter(
      (item) => item.mis_active && item.mis_active === true
    );
    this.missionsCurrentSite = this.missionsActive.filter(
      (item) =>
        item?.mis_misc?.create_on_site &&
        parseInt(item.mis_misc.create_on_site) === parseInt(this.sit_id)
    );
  },

  unmounted() {
    if (this.clearOnUnmount) {
      this.clearFlight();
    }
  },

  methods: {
    clearFlight() {
      Map?.dynamicmission?.clear();
    },

    selectFlight(flight) {
      if (flight) {
        this.displayFlight(flight);

        if (flight.mis_misc?.missionConfig?.store_crea_vol) {
          this.store_crea_vol = flight.mis_misc.missionConfig.store_crea_vol;
        }
        if (flight.mis_misc?.missionConfig?.batt_crea_vol) {
          this.batt_crea_vol = flight.mis_misc.missionConfig.batt_crea_vol;
        }
        if (flight.mis_misc?.missionConfig?.takeOffSecurityHeight) {
          this.safeheight_crea_vol =
            flight.mis_misc.missionConfig.takeOffSecurityHeight;
        }
      }
    },

    displayFlight(flight) {
      if (flight == undefined || flight == null) {
        Map.dynamicmission.clear();
      } else {
        let geom = parse(flight.mis_geom);
        Map.dynamicmission.addMission(
          geom ? geom.coordinates : [],
          [],
          flight.mis_text,
          flight.mis_id,
          false
        );
        Map.dynamicmission.flytoMission();
      }
    },

    create_flight(mission) {
      if (
        this.$root.devices.online[this.config.deviceFamilly.this_dev_id] ==
        undefined
      ) {
        toast.error(this.$e("Appareil déconnecter"), this.$root.toastConfig);
        return;
      }

      this.$root.global.startCheacklist({
        dev_id: this.config.deviceFamilly.this_dev_id,
        mission: mission,
        // ---
        true: async () => {
          this.clearOnUnmount = false;

          let data = {
            MisId: mission,
            DevId: this.config.deviceFamilly.this_dev_id,
            Batt: this.batt_crea_vol,
            Store: this.store_crea_vol,
            SafeHeight: this.safeheight_crea_vol,
          };

          let newFlightId = await API.post("flight", data);

          if (newFlightId?.flg_id == undefined) {
            toast.error(
              this.$e("Erreur lors de la création"),
              this.$root.toastConfig
            );
            return;
          }

          let flight_command = await API.put("flightexecute", {
            FlgId: newFlightId.flg_id,
          });

          this.$root.devices.online[
            this.config.deviceFamilly.this_dev_id
          ].config.flight.id = flight_command.command;
          this.$emit("close");
        },
        false: () => {
          toast.info(this.$e("Vol annuler"), this.$root.toastConfig);
        },
      });
    },
  },
};
</script>
